import { Icon } from "../../Icon";
import { IIcon } from "../../interfaces/IIcon";

export const approvalPositiveIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M32 5.333c14.704 0 26.667 11.963 26.667 26.667 0 14.704-11.963 26.667-26.667 26.667C17.296 58.667 5.333 46.704 5.333 32 5.333 17.296 17.296 5.333 32 5.333zM32 0C14.328 0 0 14.328 0 32s14.328 32 32 32 32-14.328 32-32S49.672 0 32 0zm16.667 23.71l-3.79-3.758-16.28 16.581-8.208-7.832-3.722 3.83 12 11.517 20-20.339z"/></svg>`
);
